(ns frontend.view.grid.indirect-holdings-grid.columns)

;;default set of selected columns
(def ordered-default-columns
  [:indirect-holding/fund
  :indirect-holding/holding-target])

(def default-columns
  (set ordered-default-columns))

;;always selected:
(def mandatory?
  #{:indirect-holding/fund
    :indirect-holding/holding-target})
